import { useEffect, useState } from "react";
import UIButton from "../atoms/UIButton";
import { useNavigate } from "react-router-dom";
import { welcomeMessage } from "../../services/localContent";

export default function UIHeaderOut() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  function scrollToUIServicesOut() {
    const targetElement = document.querySelector(".UIServicesOut");
    if (targetElement) { const scrollPosition = targetElement.getBoundingClientRect().top + window.scrollY - 40; window.scrollTo({ top: scrollPosition, behavior: "smooth" }); }
  }

  useEffect(() => {
    const handleResize = () => { setIsMobile(window.innerWidth < 768); };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => { window.removeEventListener("resize", handleResize); };
  }, []);

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('products');
    localStorage.removeItem('user');
  }, []);

  const { title, description, description2, description3, buttonLabel } = welcomeMessage[0];

  const backgroundImage = isMobile
    ? "/assets/images/image_banner_hero_mobile.webp"
    : "/assets/images/image_banner_hero_desktop.webp";

  return (
    <section
      className="relative overflow-hidden bg-bottom bg-contain h-[630px] md:h-[630px] md:bg-top bg-no-repeat md:bg-cover"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="md:w-[60%] flex flex-col md:items-start items-center justify-start h-full p-5 md:pl-40 text-center text-gray-900 banner-hero-content w-100 lg:w-1/2 lg:items-start lg:justify-center lg:text-left lg:pl-40">
        <h1 className="whitespace-break-spaces text-center md:text-left mt-[40px] mb-8 md:text-[40px] sm:text-[40px] text-[38px] text-[#00915A] font-BNPPSansCondExtraBold leading-[50px] font-semibold md:mt-1 md:mb-10n animate-appear-top">
          {title}
        </h1>
        <div className=" flex-col hidden gap-4 max-w-[540px] text-base lg:flex animate-appear-top text-[#58595b]">
          {description.split("/n").map((item) => (
            <p key={item}>{item}</p>
          ))}
        </div>
        <div className="  flex-col hidden gap-4 max-w-[540px] mb-8 text-base lg:flex animate-appear-top text-[#58595b]">
          {description2.split("/n").map((item) => (
            <p key={item}>{item}</p>
          ))}
        </div>
        <div className="flex-col hidden gap-4 max-w-[540px] mb-8 text-base lg:flex animate-appear-top text-[#58595b]">
          {description3.split("/n").map((item) => (
            <p key={item}>{item}</p>
          ))}
        </div>
        <UIButton onClick={() => navigate("/registro")} className="px-6 bg-secondary-green">
          {buttonLabel}
          <div className="hidden w-2 h-2 ml-4 -rotate-45 border-b-2 border-r-2 md:hidden border-b-white border-r-white" />
        </UIButton>
      </div>
      <div
        className="UIServicesOut absolute hidden md:flex text-green-600 text-[18px] cursor-pointer items-center justify-center gap-2 flex-col left-1/2 -translate-x-1/2 bottom-3"
        onClick={() => scrollToUIServicesOut()}
      >
        <div className="animate-bounce p-2 bg-[#00915A] rounded-full shadow-2xl">
          <div className="w-2 h-2 rotate-45 border-b-2 border-r-2 border-b-green border-r-green" />
        </div>
        <p className="text-[#474747] text-base font-OpenSans">Conoce más</p>
      </div>
    </section>
  );
}